export default __webpack_public_path__ + "static/media/smallIntermission4.5e4d592f.mp3";